module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "footer-nav"
  }, [_c('div', {
    staticClass: "footer-title"
  }, [_vm._v("导航")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/buy.htm"
    }
  }, [_vm._v("我要买车")]), _vm._v(" "), _vm._l((_vm.navList), function(item) {
    return _c('a', {
      attrs: {
        "href": item.url,
        "target": item.target
      }
    }, [_vm._v(_vm._s(item.text))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "footer-intro"
  }, [_c('div', {
    staticClass: "footer-title"
  }, [_vm._v("联系方式")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("联系电话：" + _vm._s(_vm.addressCall))]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "content-title"
  }, [_vm._v("通讯地址：")]), _vm._v(" "), _c('div', {
    staticClass: "content-body"
  }, [_vm._l((_vm.addressList), function(item) {
    return [_c('div', {
      staticClass: "content-body-list"
    }, [_vm._v(_vm._s(item))])]
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "footer-links"
  }, [_c('div', {
    staticClass: "footer-title"
  }, [_vm._v("友情链接")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "//www.souche.com/",
      "target": "_blank"
    }
  }, [_vm._v("大搜车")]), _vm._v(" "), _vm._l((_vm.friendLinkList), function(item) {
    return [_c('a', {
      attrs: {
        "href": item.url,
        "target": item.target
      }
    }, [_vm._v(_vm._s(item.text))])]
  })], 2), _vm._v(" "), (_vm.qrImgSrc) ? _c('div', {
    staticClass: "qr-code"
  }, [_c('div', {
    staticClass: "footer-title"
  }, [_vm._v("微信号")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.qrImgSrc
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "announcement"
  }, [_c('div', {
    staticClass: "announcement__text"
  }, [_vm._l((_vm.announcementText), function(item, index) {
    return [(index != 0) ? _c('span', [_vm._v("|")]) : _vm._e(), _vm._v(" "), _c('a', {
      attrs: {
        "href": _vm.formatUrl(item.url)
      }
    }, [_vm._v("\n                       " + _vm._s(item.text) + "\n                   ")])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "announcement__image"
  }, [_vm._l((_vm.announcementImage), function(item) {
    return [_c('a', {
      attrs: {
        "href": _vm.formatUrl(item.url)
      }
    }, [_c('img', {
      attrs: {
        "src": '//img.souche.com/' + item.image,
        "title": item.text,
        "alt": item.text
      }
    })])]
  })], 2), _vm._v(" "), _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "other"
  }, [_c('a', {
    attrs: {
      "href": "/?__mobile=true"
    }
  }, [_vm._v("进入手机版")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-215503e1!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@souche-f2e/wangzhan-modularity-footer/vue/Default.vue
// module id = 843
// module chunks = 5